import React, { useState, useEffect , useRef } from 'react'
import { withTranslation } from 'react-i18next'
import { gql, useApolloClient, useLazyQuery, useQuery } from '@apollo/client'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import { FilterProductsByCategories, getproductsforcs, searchproductforcs } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import SearchBar from '../components/TableHeader/SearchBar'
import { customStyles } from '../utils/tableStyleForManageProduct'
import useGlobalStyles from '../utils/globalStyles'
import { useHistory } from 'react-router-dom';
import { Icon } from '@iconify/react';
import {
    Container,
    Modal,
    MenuItem,
    IconButton,
    Menu,
    useTheme,
    ListItemIcon,
    Typography,
    Paper,
    Badge,
    Box, Button, FormControl, InputLabel, Select
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete'
import TableHeader from '../components/TableHeader'
import Alert from '../components/Alert'
import AddProduct from '../components/AddProduct/AddProduct'
import TuneIcon from '@mui/icons-material/Tune';
import AllPRoductFIlter from '../utils/fIlters/AllPRoductFIlter'
const LAST_PRODUCT_LIST_PAGE = 'lastProductListPage';
const LAST_PRODUCT_LIST_SCROLL_POS = 'lastProductListScrollPos';
const LAST_PRODUCT_LIST_PER_PAGE = 'lastProductListPerPage';
const IS_BACK_FROM_SKU = 'isBackFromSKU';
const LAST_SELECTED_PRODUCT_ID = 'lastSelectedProductId';



const GET_PRODUCTS = gql`
  ${getproductsforcs}
`

/*const GET_SEARCH_PRODUCTS = gql`
  ${searchproductforcs}
`*/
const GET_ALL_PRODUCT_filter = gql`
${FilterProductsByCategories}
`
const CentralAdminProducts = props => {
    const history = useHistory();
    const { t } = props;
    const [editModal, setEditModal] = useState(false)
    const [vendors, setVendor] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const userDetailsStr = localStorage.getItem('user-native');
    const userDetails = JSON.parse(userDetailsStr);
    const userStoreId = userDetails.storeId;
    const golbalClasses = useGlobalStyles()
    const client = useApolloClient();
    const [page, setPage] = useState(1);
    var [tabledata, setTabledata] = useState(null);
    const [currentPage, setCurrentPage] = useState(page);
    const [totalRows, setTotalRows] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [relaod, setReload] = useState(false)
    const [badgeContent, setbadgeContent] = useState(false);
    const [OpenFilter, setOpenFilter] = useState(false)
    var [FilterPaload, setFilterPaload] = useState({})
    var [DefaultValue, setDefaultValue] = useState({})
    var dataSearchReset = undefined
    const [filterCategory, setFilterCategory] = useState('');
    const [filterSubCategory, setFilterSubCategory] = useState('');
    const theme = useTheme();
    const tableRef = useRef(null);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [readyToQuery, setReadyToQuery] = useState(false); // Delay query execution until state is restored
    const [isResetting, setIsResetting] = useState(false);

useEffect(() => {
   const storedPage = localStorage.getItem(LAST_PRODUCT_LIST_PAGE);
  const storedScrollPos = localStorage.getItem(LAST_PRODUCT_LIST_SCROLL_POS);
  const storedPerPage = localStorage.getItem(LAST_PRODUCT_LIST_PER_PAGE);
  const storedSelectedId = localStorage.getItem(LAST_SELECTED_PRODUCT_ID);
  const storedFilterPayload = localStorage.getItem('lastProductFilterPayload');
  const storedFilterDefaults = localStorage.getItem('lastProductFilterDefaults');
  const isFilterApplied = localStorage.getItem('isFilterApplied') === 'true';
  const searchActive = localStorage.getItem('isSearchActive') === 'true';
  const lastSearchQuery = localStorage.getItem('lastProductSearchQuery');
  const backNavigated = localStorage.getItem(IS_BACK_FROM_SKU) === 'true';
  const navigatedFromSKU =  history.action === 'POP' &&
        history.location &&
        history.location.state &&
        history.location.state.fromSKU
  
  if (backNavigated && storedPage) {
    const parsedPage = parseInt(storedPage, 10);
    setPage(parsedPage);
    setCurrentPage(parsedPage);

    if (storedPerPage) {
      setPerPage(parseInt(storedPerPage, 10));
    }
    if (storedScrollPos && tableRef.current) {
            setTimeout(() => {
                tableRef.current.parentElement.parentElement.scrollTo(0, parseInt(storedScrollPos, 10));
            }, 100);
        }
    
    if (storedSelectedId) {
      setSelectedProductId(storedSelectedId);
    }

      // Restore filter payload if it was applied
    if (isFilterApplied && storedFilterPayload) {
      const parsedPayload = JSON.parse(storedFilterPayload);
      const parsedDefaults = JSON.parse(storedFilterDefaults);

      setFilterPaload(parsedPayload);
      setDefaultValue(parsedDefaults);
      setbadgeContent(true); // triggers useEffect that calls refetchfilterData
    }
// Restore search query
    if (searchActive && lastSearchQuery) {
      setSearchQuery(lastSearchQuery);
      setbadgeContent(true); // forces filter query
    }
    // Cleanup
    localStorage.removeItem(IS_BACK_FROM_SKU);
    localStorage.removeItem(LAST_PRODUCT_LIST_PAGE);
    localStorage.removeItem(LAST_PRODUCT_LIST_SCROLL_POS);
    localStorage.removeItem(LAST_PRODUCT_LIST_PER_PAGE);
    localStorage.removeItem(LAST_SELECTED_PRODUCT_ID);
    localStorage.removeItem('lastProductFilterPayload');
    localStorage.removeItem('lastProductFilterDefaults');
    localStorage.removeItem('isFilterApplied');
    localStorage.removeItem('lastProductSearchQuery');
    localStorage.removeItem('isSearchActive');
  } else if (!navigatedFromSKU) {
    // Fresh load - clear all
    setPage(1);
    setCurrentPage(1);
    localStorage.removeItem(LAST_PRODUCT_LIST_PAGE);
    localStorage.removeItem(LAST_PRODUCT_LIST_SCROLL_POS);
    localStorage.removeItem(IS_BACK_FROM_SKU);
    localStorage.removeItem(LAST_PRODUCT_LIST_PER_PAGE);
    localStorage.removeItem(LAST_SELECTED_PRODUCT_ID);
    localStorage.removeItem('lastProductFilterPayload');
    localStorage.removeItem('lastProductFilterDefaults');
    localStorage.removeItem('isFilterApplied');
    localStorage.removeItem('lastProductSearchQuery');
    localStorage.removeItem('isSearchActive');
  }

  setReadyToQuery(true); // continue fetching
}, [history.action, history.location.state]);



    const closeEditModal = () => {
        setEditModal(false);
    };

    const handleOpenFilter = () => {
        setOpenFilter(true)
    }
    const CloseFilter = () => {
        setOpenFilter(false)
    }
    const handleResetFilters = () => {
        setFilterPaload({});
        setDefaultValue({});
        setPage(1);
        setCurrentPage(1);
        setSearchQuery('');
        setReload(!relaod);
        setbadgeContent(false);
    };
    const variables = {
        storeId: userDetails.storeId,
        limit: perPage,
        skip: (page - 1) * perPage,
    };


    const variablesSearch = {
        text: searchQuery,
        limit: perPage,
        skip: (page - 1) * perPage,
    };

    const { loading: loadingQuery, error: errorQuery, data, refetch } = useQuery(
        GET_PRODUCTS, {
        skip: !readyToQuery,
        variables,
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            !searchQuery && !badgeContent && setTabledata(data && data.getProductsForCS.products ? data.getProductsForCS.products : [])
            !searchQuery && !badgeContent && setTotalRows(data.getProductsForCS.totalCount);
        },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    }
    )

    /*const { data: dataSearch, refetch: refetchSearch } = useQuery(
        GET_SEARCH_PRODUCTS, {
        variables: variablesSearch,
        fetchPolicy: "no-cache",
        onCompleted: (dataSearch) => {
            dataSearchReset = dataSearch && dataSearch.searchProductsCS.products
            setTabledata(dataSearch && dataSearch.searchProductsCS.products ? dataSearch.searchProductsCS.products : [])
            setTotalRows(dataSearch.searchProductsCS.totalCount);
        },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    }
    )*/

    const [refetchfilterData] = useLazyQuery(GET_ALL_PRODUCT_filter, {
        fetchPolicy: 'no-cache',
        onCompleted: (resultData) => {
            if (resultData && resultData.filterProductsByCategories) {
                CloseFilter()
               
                setTabledata(resultData.filterProductsByCategories.products || []);
                setTotalRows(resultData.filterProductsByCategories.totalCount || 0);
            }
        },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });

    const filterData = (filterInput) => {
    
      setDefaultValue(filterInput);
      const itemsPerPageFromFilter = filterInput.itemsPerPage ? parseInt(filterInput.itemsPerPage, 10) : perPage;
     
      setFilterPaload({
          "categoryId": filterInput.orderStatus,
          "subCategoryId": filterInput.workerStatus,
           "text": searchQuery || "",
          "limit": itemsPerPageFromFilter,
          "skip": 0,
      });
      setbadgeContent(true);
      setPage(1); // Reset page to 1 immediately upon filtering
      setPerPage(itemsPerPageFromFilter); // Update perPage based on filter
  };
    const onChangeSearch = e => {
      const value = e.target.value;
      setSearchQuery(value);
      setPage(1);

      // If filter is active → search inside filter
      if (badgeContent) {
        refetchfilterData({
          variables: {
            categoryId: FilterPaload.categoryId || "",
            subCategoryId: FilterPaload.subCategoryId || "",
            text: value,
            limit: perPage,
            skip: 0,
          },
        });
      } else {
        // Search only (no filter)
        refetchfilterData({
          variables: {
            categoryId: "",
            subCategoryId: "",
            text: value,
            limit: perPage,
            skip: 0,
          },
        });
      }
    };

    const handleFilterPopupReset = () => {
      setFilterPaload({});
      setDefaultValue({});
      setbadgeContent(false);   // 🔥 MOST IMPORTANT
      setSearchQuery('');
      setPage(1);
      setCurrentPage(1);
    };
    const onClickRefetch = () => {
      setIsResetting(true);
      setPage(1);
      setCurrentPage(1);
      setSearchQuery('')
      //refetch()
      setbadgeContent(false)
      //setReload(!relaod)
      setFilterPaload({});
      setDefaultValue({});
      //dataSearchReset = undefined
    }

    /*useEffect(() => {
        if (data && data.getProductsForCS.products && dataSearchReset == undefined) {
            !searchQuery && !badgeContent && setTabledata(data && data.getProductsForCS.products ? data.getProductsForCS.products : [])
            !searchQuery && !badgeContent && setTotalRows(data.getProductsForCS.totalCount);
        } else if (dataSearch && dataSearch.searchProductsCS.products) {
            setTabledata(dataSearch && dataSearch.searchProductsCS.products ? dataSearch.searchProductsCS.products : [])
            setTotalRows(dataSearch.searchProductsCS.totalCount);
        }
    }, [data, dataSearch, relaod, searchQuery, badgeContent]);*/
    

    useEffect(() => {
      if (!readyToQuery) return;

      // HARD RESET PATH
      if (isResetting) {
        refetch({ variables }).then(result => {
          if (result && result.data && result.data.getProductsForCS) {
            setTabledata(result.data.getProductsForCS.products || []);
            setTotalRows(result.data.getProductsForCS.totalCount || 0);
          }
          setIsResetting(false);
        });
        return;
      }
      // FILTER / SEARCH PATH
      if (badgeContent || searchQuery) {
        refetchfilterData({
          variables: {
            categoryId: FilterPaload.categoryId || "",
            subCategoryId: FilterPaload.subCategoryId || "",
            text: searchQuery || "",
            limit: perPage,
            skip: (page - 1) * perPage,
          },
        });
      } else {
        // NORMAL LOAD
        refetch({ variables });
      }
    }, [page, perPage, badgeContent, searchQuery, isResetting]);


      const handlePerRowChange = (newPerPage) => {
      setPerPage(newPerPage);
      setPage(1);
      //setCurrentPage(1);
     };


      const handlePageChange = (newPage) => {
      setPage(newPage);
      setCurrentPage(newPage);
    };

    const toggleModal = vendor => {
        setEditModal(!editModal)
        setVendor(vendor)
    }

    useEffect(() => {
        localStorage.removeItem('restaurant_id')
    }, [])

    const customSort = (rows, field, direction) => {
        const handleField = row => {
            if (row[field]) {
                return row[field].toLowerCase()
            }
            return row[field]
        }
        return orderBy(rows, handleField, direction)
    }

    const columns = [
        {
            name: "Product ID",
            selector: '_id'
        },
        {
            name: "Product Name",
            selector: 'name',
            style: { cursor: 'pointer', minWidth: "250px" },
        },
        {
            name: "Quantity",
            selector: 'skus',
            cell: row => {
              if (!row.skus || !Array.isArray(row.skus)) {
                return 'N/A';
              }

              const matchingSku = row.skus.find(sku =>
                sku.Stock &&
                Array.isArray(sku.Stock) &&
                sku.Stock.some(stock => stock.storeId === userStoreId)
              );

              if (matchingSku && matchingSku.Stock) {
                const matchingStock = matchingSku.Stock.find(
                  stock => stock.storeId === userStoreId
                );
                return matchingStock && matchingStock.quantity != null
                  ? matchingStock.quantity
                  : 'N/A';
              }

              return 'N/A';
            },

        },
        {
            name: "Aliases",
            cell: row => row.aliases.join(', '),
            style: { cursor: 'pointer', minWidth: "250px" },
        },
        {
            name: "Catalog Name",
            selector: 'catalog.name',
            style: { cursor: 'pointer', minWidth: "300px" },
        },
        {
            name: "Category",
            selector: 'category.name',
            style: { cursor: 'pointer', minWidth: "300px" },
        },
        {
            name: "Default Image",
            cell: row => (
                <img
                    src={row.defaultImage}
                    alt={row.displayName}
                    style={{ width: 50, height: 50 }}
                />
            )
        },
        {
            name: "HSN",
            selector: 'hsn'
        },
        {
            name: t('Action'),
            cell: row => <>{actionButtons(row)}</>
        }
    ];


    const actionButtons = row => {
        const [anchorEl, setAnchorEl] = React.useState(null)
        const open = Boolean(anchorEl)
        const handleClick = event => {
            setAnchorEl(event.currentTarget)
        }
        const handleClose = () => {
            setAnchorEl(null)
        }
        return (
            <>
                <div>
                    <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-haspopup="true"
                        onClick={handleClick}>
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    <Paper>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button'
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}>
                            <MenuItem
                                onClick={e => {
                                  e.preventDefault();

                                  // Save current row to localStorage
                                  localStorage.setItem('skuRow', JSON.stringify(row));

                                  // Save pagination and scroll
                                  localStorage.setItem(LAST_PRODUCT_LIST_PAGE, page.toString());
                                  if (tableRef.current) {
                                    localStorage.setItem(
                                      LAST_PRODUCT_LIST_SCROLL_POS,
                                      tableRef.current.parentElement.parentElement.scrollTop.toString()
                                    );
                                  }
                                  localStorage.setItem(IS_BACK_FROM_SKU, 'true');
                                  localStorage.setItem(LAST_PRODUCT_LIST_PER_PAGE, perPage.toString());
                                  localStorage.setItem(LAST_SELECTED_PRODUCT_ID, row._id);
                                  setSelectedProductId(row._id);
                                  //  Save search query if present
                                  if (searchQuery) {
                                    localStorage.setItem('isSearchActive', 'true');
                                    localStorage.setItem('lastProductSearchQuery', searchQuery);
                                  } else {
                                    localStorage.setItem('isSearchActive', 'false');
                                    localStorage.removeItem('lastProductSearchQuery');
                                  }

                                  // Save filters if applied
                                  if (badgeContent) {
                                    localStorage.setItem('lastProductFilterPayload', JSON.stringify(FilterPaload));
                                    localStorage.setItem('lastProductFilterDefaults', JSON.stringify(DefaultValue));
                                    localStorage.setItem('isFilterApplied', 'true');
                                  } else {
                                    localStorage.removeItem('lastProductFilterPayload');
                                    localStorage.removeItem('lastProductFilterDefaults');
                                    localStorage.setItem('isFilterApplied', 'false');
                                  }

                                  // Navigate
                                  history.push({
                                    pathname: '/cs_admin/sku',
                                    state: { fromProductList: true }
                                  });
                                }}
                                style={{ height: 25 }}
                              >
  
                                <ListItemIcon>
                                    <VisibilityIcon fontSize="small" style={{ color: 'black' }} />
                                </ListItemIcon>
                                <Typography color="green">{t('Manage SKU')}</Typography>
                            </MenuItem>
                            <MenuItem
                                disabled
                                onClick={e => {
                                    e.preventDefault()
                                    setIsOpen(true)
                                    setTimeout(() => {
                                        setIsOpen(false)
                                    }, 5000)
                                }}
                                style={{ height: 25 }}>
                                <ListItemIcon>
                                    <DeleteIcon fontSize="small" style={{ color: 'red' }} />
                                </ListItemIcon>
                                <Typography color="red">{t('Delete')}</Typography>
                            </MenuItem>
                        </Menu>
                    </Paper>
                </div>
            </>
        )
    }
    const downloadCSV = (tableDataCVS) => {
        const csvRows = [];
      
        const headers = [
          '_id',
          'Product Name',
          'Is Active',
          'Minimum Quantity',
          'Quantity',
          //'Aliases',
          'Unit',
          'Measure',
          'Stock Units',
          'MRP',
          'Premium Price Selling Price', // You might need to adjust how you get this
          'Retail Price Selling Price',  // You might need to adjust how you get this
          //'Sort Order',                  // This doesn't seem to be directly in this product structure
          'Catalog Name',
          'Category',  
          'Sub Category',              // This is nested
        ];
        csvRows.push(headers.join(','));
      
        tableDataCVS.forEach((row) => {
          // Extract quantity based on your existing logic
          let quantity = 'N/A';
          if (row.skus && Array.isArray(row.skus)) {
            const matchingSku = row.skus.find(
              (sku) =>
                sku.Stock && sku.Stock.some((stock) => stock.storeId === userStoreId)
            );
            if (matchingSku) {
              const matchingStock = matchingSku.Stock.find(
                (stock) => stock.storeId === userStoreId
              );
              if (matchingStock) {
                quantity = matchingStock.quantity;
              }
            }
          }
      
          const rowData = [
            row._id,
            row.name,
            row.isActive,
            row.skus && row.skus[0] ? row.skus[0].minimumQty : '', // Access from skus array
            quantity,
            //row.aliases ? row.aliases.join(', ') : '',
            row.skus && row.skus[0] ? row.skus[0].unit : '',     // Access from skus array
            row.skus && row.skus[0] ? row.skus[0].measure : '',  // Access from skus array
            row.skus && row.skus[0] ? row.skus[0].stockUnits : '', // Access from skus array
            row.skus && row.skus[0] ? row.skus[0].mrp : '',        // Access from skus array
            row.skus && row.skus[0] && row.skus[0].prices && row.skus[0].prices[0] ? row.skus[0].prices[0].sellingPrice : '', // Example: Premium price
            row.skus && row.skus[0] && row.skus[0].prices && row.skus[0].prices[1] ? row.skus[0].prices[1].sellingPrice : '', // Example: Retail price
            //row.sortOrder || '', // This doesn't seem to be directly available
             row.catalog ? row.catalog.name : '',
            row.category ? row.category.name : '',
            row.category && row.category.subcategories && row.category.subcategories[0] ? row.category.subcategories[0].name : '', // Access nested subcategory
          ];
          csvRows.push(rowData.join(','));
        });
      
        const csvContent = `data:text/csv;charset=utf-8,${csvRows.join('\n')}`;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'Products_Report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    
      const handleDownloadCSV = async () => {
        try {
          const { data } = await client.query({
            query: GET_PRODUCTS, // Fetch all products
            variables: {
              storeId: userDetails.storeId,
              limit: totalRows, // Fetch all rows instead of just perPage
              skip: 0,
            },
            fetchPolicy: "no-cache",
          });
      
          const fullData = data.getProductsForCS.products || [];
          
          if (fullData.length > 0) {
            downloadCSV(fullData);
          } else {
            alert("No data to download.");
          }
        } catch (error) {
          console.error("Error fetching full product data:", error);
          alert("Failed to fetch full data for download.");
        }
      };
      const conditionalRowStyles = [
        {
          when: row => row._id === selectedProductId,
          style: {
          backgroundColor: theme.palette.action.selected, // Or any highlighting color

          },
        },
      ];

    
    return (
      <>
        <Header />
        <Box sx={{ textAlign: 'right', mb: 3 }}>
        <Button onClick={handleDownloadCSV} className={golbalClasses.dashbordBtn}>
                    <Icon icon="ic:round-download" style={{ color: "white" }} /> {t('Download CSV')}
                  </Button>
                  </Box>
        <Container className={golbalClasses.flex}>
          {errorQuery ? <span> Error! ${errorQuery.message}</span> : null}
          {loadingQuery ? (
            <CustomLoader />
          ) : (
            <DataTable
              key={perPage} 
              ref={tableRef} // Attach ref to DataTable
              subHeader={true}
              subHeaderComponent={
                <>
                  <SearchBar
                    value={searchQuery}
                    onChange={onChangeSearch}
                    onClick={() => onClickRefetch(refetch)}
                  />
                  <Box style={{ marginTop: -40 }}>
                    {badgeContent === true ? (
                      <Badge
                        badgeContent={''}
                        color="success"
                        variant="dot"
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                      >
                        <Button
                          onClick={handleOpenFilter}
                        >
  
                          <TuneIcon />
                        </Button>
                      </Badge>
                    ) : <Button
                      onClick={handleOpenFilter}
                    >
  
                      <TuneIcon />
                    </Button>}
                  </Box>
                 
                </>
              }
              title={<TableHeader title={t('CS Manage Products ')} />}
              columns={columns}
              data={tabledata || []}
              progressPending={loadingQuery}
              progressComponent={<CustomLoader />}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowChange}
              onChangePage={handlePageChange}
              // sortFunction={customSort}
  
              customStyles={customStyles}
              conditionalRowStyles={conditionalRowStyles} // Apply conditional styles

            />
          )}
          
          <Modal
            open={editModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            BackdropProps={{
              onClick: (e) => {
                e.stopPropagation(); // Prevent the modal from closing
              }
            }}
            onClose={() => {
              toggleModal()
            }}>
            <AddProduct vendor={vendors} onClose={closeEditModal} />
          </Modal>
          {/* <Modal
            open={skuModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClose={() => {
              toggleModal()
            }}>
            <EditProductQuantityCS vendor={vendors} onClose={closeSkuModal} />
          </Modal> */}
  
  
          {OpenFilter &&
            <AllPRoductFIlter open={OpenFilter} close={CloseFilter} filterData={filterData} DefaultValue={DefaultValue} handleResetFilters={handleResetFilters} />
          }
        </Container>
      </>
    )
  } 
  export default withTranslation()(CentralAdminProducts)
